(function () {
  var show_guide_button = document.querySelector('.size-chart-open-popup');
  var size_guide_modal = document.querySelector('.modal__sizeguide');
  var close_modal = document.querySelector('.close-modal');
  var modal_overlay = document.querySelector('.modal-overlay');
  var js_toggle_in = document.querySelector('.js-toggle-in');
  var js_toggle_cm = document.querySelector('.js-toggle-cm');
  
  show_guide_button.addEventListener('click', (event) => {
    size_guide_modal.classList.add('show');
    modal_overlay.classList.add('modal-open');
  });

  close_modal.addEventListener('click', (event) => {
    size_guide_modal.classList.remove('show');
    modal_overlay.classList.remove('modal-open');
  });

  js_toggle_in.addEventListener('click', (event) => {
    document.querySelectorAll('.sizeguide__toggle li').forEach((element) => {
      if(element.classList.contains('js-parent-in')) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });

    document.querySelectorAll('.js-data-in').forEach((el) => {
      el.style.display = "";
    });

    document.querySelectorAll('.js-data-cm').forEach((el) => {
      el.style.display = "none";
    });
  });

  js_toggle_cm.addEventListener('click', (event) => {
    document.querySelectorAll('.sizeguide__toggle li').forEach((element) => {
      if(element.classList.contains('js-parent-cm')) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });

    document.querySelectorAll('.js-data-cm').forEach((el) => {
      el.style.display = "";
    });

    document.querySelectorAll('.js-data-in').forEach((el) => {
      el.style.display = "none";
    });
  });
})();